import {type DocumentFieldAction} from './types'

/** @internal */
export function defineDocumentFieldAction(fieldAction: DocumentFieldAction): DocumentFieldAction {
  return fieldAction
}
